import { observer } from 'mobx-react';
import SchoolPartnerLogo from '../SchoolPartner/SchoolPartnerLogo';

function ExperiencesHeaderLogo() {
  return <SchoolPartnerLogo height={38} />;
}

export default observer(ExperiencesHeaderLogo);
